module.exports = __webpack_public_path__ + "img/rhymeflip.96fdf8c4.png";